import { fileToBase64 } from "./fileToBase64";
import { firestoreAutoId } from "./firestoreAutoId";

export async function processFiles(files, relation_field, relation_id) {
  var allPics = [];
  for (var i = 0; i < files.length; i++) {
    //make sure not larger than 40 megs
    if (files[i].size > 50000000) {
      throw Error(
        `Sorry, this file is over 50 megabytes: ${files[i].name} - File is to large.`
      );
    } else {
      //Set Icon image
      var fl = {};
      fl.id = "new_" + firestoreAutoId();
      fl.comment = "";
      fl.file = await fileToBase64(files[i]);
      fl.name = files[i].name;
      fl.deleted = false;
      fl.size = files[i].size;
      fl[relation_field] = relation_id;
      allPics.push(fl);
    }
  }
  return allPics;
}
